export default __webpack_public_path__ + "static/media/inactivebell.112600d8.svg";